"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadController = void 0;
var DownloadController = /** @class */ (function () {
    function DownloadController(logger) {
        var _this = this;
        this.logger = logger;
        this.is_ios = /(iPhone|iPod|iPad)/i.test(navigator.userAgent);
        this.max_bytes_ios = 200 * 1024 * 1024;
        this.bytesDownloadedLastSection = 0;
        this.config = {
            server: {
                testServers: []
            }
        };
        this.download_time = 1;
        this.download_interval_time = 750;
        this.bytesDownloadedGet = [];
        this.num_download_streams = 6;
        this.download_streams = [];
        this.downloadSectionCurrentTime = null;
        this.downloadSectionStartTime = null;
        this.downloadStartTime = null;
        this.stopHandler = null;
        this.sectionHandler = null;
        this.result = {
            overall_time: {
                download: 0
            },
            overall_bytes: {
                download: 0
            },
            download_raw: []
        };
        this.onDownloadIntermediate = function (speed_bps) { };
        this.onDownloadComplete = function () { };
        this.onError = function (err) { };
        this.onTimeout = function (err) { };
        this.startDownload = function () {
            _this.logger.info("DownloadController.startDownload");
            var self = _this;
            self.bytesDownloadedLastSection = 0;
            for (var i = 0; i < self.config.server.testServers.length; i++) {
                self.bytesDownloadedGet[i] = [];
                for (var j = 0; j < self.num_download_streams; j++) {
                    self.bytesDownloadedGet[i][j] = 0;
                    var downloadStream = {
                        url: "".concat(self.config.server.testServers[i], "?").concat(Math.random()),
                        req: new XMLHttpRequest(),
                        updateProgress: function (evt) {
                            if (this.id === undefined || this.testServer === undefined) {
                                self.logger.error("XMLHttpRequest expect to have a customer id and testServer property initialized");
                                return;
                            }
                            self.bytesDownloadedGet[this.testServer][this.id] = evt.loaded;
                            self.downloadSectionCurrentTime = new Date();
                        },
                    };
                    downloadStream.req.id = j;
                    downloadStream.req.testServer = i;
                    // downloadStream.req.open("GET", downloadStream.url, true);
                    downloadStream.req.onprogress = downloadStream.updateProgress;
                    downloadStream.req.onload = self.getSectionSpeed;
                    downloadStream.req.onerror = self.onDownloadError; // TODO: Decide how to handle those errors
                    downloadStream.req.onabort = self.getSectionSpeed;
                    downloadStream.req.ontimeout = self.onDownloadTimeout;
                    downloadStream.req.responseType = "arraybuffer";
                    downloadStream.req.open("GET", downloadStream.url, true);
                    self.download_streams.push(downloadStream);
                }
            }
            self.sectionHandler = window.setInterval(self.getSectionSpeed, self.download_interval_time);
            self.stopHandler = window.setTimeout(self.finish, self.download_time * 1000);
            self.downloadStartTime = new Date();
            self.downloadSectionStartTime = self.downloadStartTime;
            for (var k = 0; k < self.download_streams.length; k++) {
                self.download_streams[k].req.send();
            }
        };
        this.getSectionSpeed = function (ev) {
            var self = _this;
            if (self.downloadStartTime === null ||
                self.downloadSectionStartTime === null ||
                self.downloadSectionCurrentTime === null) {
                return;
            }
            var bytesLoadedUntilNow = self.getBytesUntilNow();
            var currentTime = self.downloadSectionCurrentTime;
            var newBytes = bytesLoadedUntilNow - self.bytesDownloadedLastSection;
            var newTime = currentTime.getTime() - self.downloadSectionStartTime.getTime();
            if (newBytes > 0 && newTime > 0) {
                self.bytesDownloadedLastSection = bytesLoadedUntilNow;
                self.downloadSectionStartTime = self.downloadSectionCurrentTime;
                var newSpeed = Math.round((8 * newBytes) / newTime);
                var overallTime = currentTime.getTime() - self.downloadStartTime.getTime();
                var progress = overallTime / 10 / self.download_time;
                self.result.overall_time.download = overallTime;
                self.result.overall_bytes.download = bytesLoadedUntilNow;
                if (self.is_ios && bytesLoadedUntilNow > self.max_bytes_ios) {
                    self.finish();
                }
                if (newTime > 50) {
                    /* at least 50ms to get reasonable values */
                    self.result.download_raw.push(newSpeed);
                    self.onDownloadIntermediate(newSpeed * 1e3);
                }
            }
        };
        this.getBytesUntilNow = function () {
            var self = _this;
            var bytesLoadedUntilNow = 0;
            for (var i = 0; i < self.config.server.testServers.length; i++) {
                for (var j = 0; j < self.num_download_streams; j++) {
                    bytesLoadedUntilNow += self.bytesDownloadedGet[i][j];
                }
            }
            return bytesLoadedUntilNow;
        };
        this.finish = function () {
            _this.logger.info("DownloadController.finish");
            _this.stop();
            _this.onDownloadComplete();
        };
        this.stop = function () {
            _this.logger.info("DownloadController.stop");
            _this.stopHandler && window.clearTimeout(_this.stopHandler);
            _this.sectionHandler && window.clearInterval(_this.sectionHandler);
            _this.stopHandler = null;
            for (var i = 0; i < _this.download_streams.length; i++) {
                _this.download_streams[i].req.abort();
            }
        };
        this.onDownloadError = function (ev) {
            _this.logger.error(ev, "DownloadController.onDownloadError");
            _this.onError(ev);
        };
        this.onDownloadTimeout = function (ev) {
            _this.logger.error(ev, "DownloadController.onDownloadTimeout");
            _this.onTimeout(ev);
        };
    }
    return DownloadController;
}());
exports.DownloadController = DownloadController;
//# sourceMappingURL=DownloadController.js.map